import { useQuery } from '@tanstack/react-query';
import { ApiError } from '@root/globalTypes';
import { queryKeys } from '@utils/consts';
import { queryFetch } from '@services/api';
import { WorkloadCalendarSidebarRespSuccess } from './types';
import { useQueryParams } from '@hooks/queryParams';
import { camelToSnakeCase } from '@utils/textHelpers';
import { WorkloadSidebarTab } from '@contexts/workload/types';

export const useGetWorkloadCalendarSidebar = (tabName?: WorkloadSidebarTab, page?: number) => {
  const { params, parseParams } = useQueryParams();

  const { team, searchSidebar, divisionIds, workflowIds, taskTypes } = params;

  const queryParams = parseParams(
    {
      search: searchSidebar,
      tabName,
      team: team?.map((el) => camelToSnakeCase(el)),
      divisionIds,
      workflowIds,
      taskTypes,
      page: tabName === 'jobs' ? page : undefined,
    },
    { arrayFormat: 'bracket' },
  );

  const { data, error, isPending } = useQuery<WorkloadCalendarSidebarRespSuccess, ApiError>({
    queryKey: [...queryKeys.workloadCalendarSidebar, tabName, queryParams],
    queryFn: async () => await queryFetch({ url: `workloads/calendar_sidebar${queryParams}` }),
    placeholderData: (previousData) => previousData as WorkloadCalendarSidebarRespSuccess,
    enabled: Boolean(tabName),
  });

  return {
    data,
    error,
    isLoading: isPending && Boolean(tabName),
  };
};
